import mainStyle from "../mainStyle.module.scss";

import React from "react";
import { useTheme } from "@mui/material/styles";
import icn_expand_right from "assets/images/icons/icn_expandright.svg";

const SubMenu = ({ nowAnchor, item, setNowAnchor }) => {
  const theme = useTheme();

  return (
    <div key={item.key}>
      <div
        className={mainStyle["subAnchorItem"]}
        style={{
          backgroundColor:
            nowAnchor === item.key
              ? theme.palette.primary.subBlue
              : "",
        }}
        onClick={() => setNowAnchor(item.key)}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span
              style={{
                width: "6px",
                height: "6px",
                backgroundColor: theme.palette.primary.main,
                margin: "2.5px 10px 2.5px 0",
                borderRadius: "2px",
                display: "inline-block",
              }}
            />
            <span
              className={mainStyle["subAnchorItem_text"]}
              style={{ color: theme.palette.primary.main }}
            >
              {item.label}
            </span>
          </div>
          {item.showArrow && <img src={icn_expand_right} alt='' />}
        </div>
      </div>
    </div>
  );
}

export default SubMenu;